<template>
  <div style="font-size: 50px">
    <h5 style="color: orangered"><i class="el-icon-star-on"></i>使用说明</h5>
    <el-alert
      :closable="false"
      type="error">
      <i class="el-icon-check"></i> <span>请谨慎操作，尽量不要因为操作不当给公司客户带来损失。</span>
    </el-alert>
    <el-alert
      style="margin-top: 5px"
      :closable="false"
      type="error">
      <i class="el-icon-check"></i> <span>如果在使用过程中发现数据不对的地方，请及时跟技术确认并解决。</span>
    </el-alert>
    <el-collapse v-model="activeNames" style="text-align: left; color: #ec7171; font-size: 30px">
      <el-collapse-item title="用户管理" name="1">
        <div>该页面主要用于用户的管理功能，在搜索页，选择或输入相应的条件，点击查询就可以看到用户列表，然后点击用户编号就可以进入到用户详情页；</div>
        <div>在用户详情页中，可以查看跟用户相关的所有功能，在会员详情页面，还可以主动帮用户激活会员卡，此功能主要针对老系统客户的迁移；</div>
      </el-collapse-item>
      <el-collapse-item title="代理商管理" name="2">
        <div>列表页功能跟用户管理一样；</div>
        <div>在详情页面中，可以完成入驻审核，机油发货，成本入库等等操作；</div>
      </el-collapse-item>
      <el-collapse-item title="其它" name="3">
        <div>待补充</div>
      </el-collapse-item>
    </el-collapse>

    <el-image :src="image" style="border-radius: 20px; margin-top: 10px"></el-image>
  </div>
</template>

<script>
import declaration from '@/assets/declaration.jpeg'

export default {
  name: "Home",
  data() {
    return {
      activeNames: [],
      image: declaration
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue